
function ItemCommentCount({ count }) {

    return (
        
        <div>
            <span>{count} characters </span> 
            <span> / ( </span> 
            <span className={count < 25 ? "color-error-darkred": "color-success-darkgreen"}>25 min</span> 
            <span> | 2000 max )</span>
        </div>
    );
}

export default ItemCommentCount;